<div class="relative">
  <div #stickyHeader class="sticky top-0 z-50 flex flex-col">
    <app-header></app-header>
    <app-maintenance-banner></app-maintenance-banner>
  </div>
  <div class="flex">
    <!-- CONTENT -->
    @if(!isNoPermissionPage){
    <app-sidebar></app-sidebar>
    }
    <div style="contain: inline-size" class="flex-1 bg-white w-full">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
